import { getI18n } from '@/lang'
const i18n = getI18n()

const state = {
  curIndex: null, // 存储树形列表当前处于什么状态
  departmentList: [], // 部门列表
  attenDevList: [], // 关心的人列表
  orgGroupList: [], // 群组列表
  departmentFunc: null, // 获取部门列表的Function
  setUserAttenFunc: null, // 获取关注列表的Function
  orgGroupFunc: null, // 获取群组列表的Function
  deviceTreeList: [], // 群组列表、部门列表
  devicesFilesList: [], // 查看设备媒体文件
  allDeviceList: [],
  orgTreeDeviceList: [],
  storeCallback: {},
  orgGroupId: null
}
const getters = {
  orgGroupId(state) {
    return state.orgGroupId
  },
  curIndex(state) {
    return state.curIndex
  },
  allDeviceList(state) {
    return state.allDeviceList
  },
  attenDevList(state) {
    return state.attenDevList || []
  },
  deviceTreeList(state) {
    return state.deviceTreeList || []
  },
  devicesFilesList(state) {
    return state.devicesFilesList || []
  },
  departmentList(state) {
    return state.departmentList || []
  },
  orgTreeDeviceList(state) {
    return state.orgTreeDeviceList || []
  },
  orgGroupList(state) {
    return state.orgGroupList || []
  }
}

const mutations = {
  addStoreCallback(state, obj) {
    state.storeCallback[`${obj.name}`] = obj.callback
  },
  useStoreCallback(state, obj) {
    state.storeCallback[`${obj.name}`](obj.data)
  },
  curIndexFn(state, curIndex) {
    state.curIndex = curIndex
  },
  /* 获取设备列表 */
  handlerReloadUserAtten(state) {
    state.setUserAttenFunc()
  },
  setUserAttenFunc(state, fn) {
    state.setUserAttenFunc = fn
  },
  setAttenDevList(state, payload) {
    state.attenDevList = payload
  },

  /**
   * 存入部门列表
   * @param state
   * @param payload
   */
  setDepartmentList(state, payload) {
    state.departmentList = payload
  },
  /**
   * 存入群组列表
   * @param state
   * @param payload
   */
  setOrgGroupList(state, payload) {
    state.orgGroupList = payload
  },
  /**
   * 存入获取部门列表的Function
   * @param state
   * @param payload
   */
  setDepartmentFunc(state, payload) {
    state.departmentFunc = payload
  },
  /**
   * 存入获取群组的Function
   * @param state
   * @param payload
   */
  setOrgGroupFunc(state, payload) {
    state.orgGroupFunc = payload
  },
  addDepartmentListFn(state, res) {
    const increaseQuantity = 5
    const childrenDeviceList = res.childrenDeviceList
    const quantity = res.childrenDeviceNum + increaseQuantity
    const list = []
    // eslint-disable-next-line no-unused-vars
    let quantityType = null
    if (childrenDeviceList.length >= quantity) {
      quantityType = 2
      for (
        let i = res.childrenDeviceNum;
        i < res.childrenDeviceNum + increaseQuantity;
        i++
      ) {
        list.push(childrenDeviceList[i])
      }
    } else {
      quantityType = 1
      const remainingQuantity =
        childrenDeviceList.length - res.childrenDeviceNum
      for (
        let i = res.childrenDeviceNum;
        i < res.childrenDeviceNum + remainingQuantity;
        i++
      ) {
        list.push(childrenDeviceList[i])
      }
    }
    res.childrenDeviceNum = res.childrenDeviceNum + list.length
    const row = {
      ...res,
      name: i18n.t('loadMore')
    }
    const findItem = (item) => {
      item.forEach((val) => {
        let type = true
        if (val.id === res.parentid && val.children && val.children.length) {
          type = false
          const indexName = val.children.length - 1
          const current = document.getElementById(`load${res.parentid}`)
          if (current) {
            const currentParentNode = current.parentNode
            currentParentNode.parentNode.removeChild(currentParentNode)
          }
          val.children.splice(indexName, 1)
          val.children.push(...list)
          if (quantityType === 2) {
            val.children.push({ ...row })
          }
        }
        if (val.children && val.children.length > 0 && type) {
          findItem(val.children)
        }
      })
    }
    findItem(state.departmentList)
  },
  orgTreeDeviceList(state, deviceList) {
    state.orgTreeDeviceList = deviceList
  },
  /**
   * @param state
   * @param payload
   */
  handlerDeviceStateChange(state, payload) {
    const orgTreeDeviceList = state.orgTreeDeviceList
    const orgTreeDeviceListRow = orgTreeDeviceList.find(
      (v) => v.deviceId === payload.deviceId
    )
    if (orgTreeDeviceListRow) {
      const parentIdsList = orgTreeDeviceListRow.parentIdsList
      const num = 0
      const findItem = (list, num) => {
        const json = parentIdsList[num]
        if (json) {
          const index = parentIdsList[num].currentSubscript
          const item = list[index]
          if (item && item.children) {
            if (payload.isofn === 1) {
              const onlineCountListIndex = item.onlineCountList.findIndex(
                (v) => v.deviceId === payload.deviceId
              )
              if (onlineCountListIndex === -1) {
                if (payload.onlineState === 1) {
                  item.onlineCountList.push(payload)
                }
              } else {
                if (payload.onlineState !== 1) {
                  item.onlineCountList.splice(onlineCountListIndex, 1)
                }
              }
            }
            if (parentIdsList.length - 1 === num) {
              const childrenIndex = item.children.findIndex(
                (v) => v.deviceId === payload.deviceId
              )
              if (childrenIndex !== -1) {
                const deviceItem = item.children[childrenIndex]
                deviceItem.intercomCall = payload.intercomCall
                deviceItem.intercomGroupNature = payload.intercomGroupNature
                deviceItem.intercomGroupTem = payload.intercomGroupTem
                deviceItem.onlineState = payload.onlineState
              }
            } else {
              num++
              findItem(item.children, num)
            }
          }
        }
      }
      findItem(state.departmentList, num)
    }
  },

  groupHandlerDeviceStateChange(state, payload) {
    if (state.orgGroupList.length > 0) {
      const findItem = (list) => {
        list.forEach((val) => {
          val.children &&
            val.children.forEach((deviceItem) => {
              if (deviceItem.deviceId === payload.deviceId) {
                deviceItem.intercomCall = payload.intercomCall
                deviceItem.intercomGroupNature = payload.intercomGroupNature
                deviceItem.intercomGroupTem = payload.intercomGroupTem
                deviceItem.onlineState = payload.onlineState
              }
            })
          if (val.children && val.children.length > 0) {
            findItem(val.children)
          }
        })
      }
      findItem(state.orgGroupList)
    }
  },
  attenHandlerDeviceStateChange(state, payload) {
    if (state.attenDevList.length > 0) {
      const findItem = (list) => {
        list.forEach((val) => {
          // const index = val.deviceList.findIndex(v => v.deviceId === payload.deviceId)
          // if (index !== -1) {
          //   val.deviceList[index] = {
          //     ...val.deviceList[index],
          //     ...payload
          //   }
          // }
          val.children &&
            val.children.forEach((deviceItem) => {
              if (deviceItem.deviceId === payload.deviceId) {
                deviceItem.intercomCall = payload.intercomCall
                deviceItem.intercomGroupNature = payload.intercomGroupNature
                deviceItem.intercomGroupTem = payload.intercomGroupTem
                deviceItem.onlineState = payload.onlineState
              }
            })
          if (val.children && val.children.length > 0) {
            findItem(val.children)
          }
        })
      }
      findItem(state.attenDevList)
    }
  },
  setAllDeviceList(state, payload) {
    state.allDeviceList = payload
  },
  /* 群组id（用于指挥中心群组在发起对讲的时候高亮） */
  orgGroupIdFn(state, orgGroupId) {
    state.orgGroupId = orgGroupId
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}
